import Text from '@/components/ui/Text';
import { Article } from '@/features/blog/listing/BlogCard';
import FeaturedArticleCard from '@/features/blog/listing/FeaturedArticleCard';
import { BlogI18n } from '@/lib/i18n/blogI18n';

const BlogTopSection = ({ featuredArticles, t }: BlogTopSectionProps) => {
  if (featuredArticles.length === 0) return null;

  return (
    <div className="mb-20">
      <Text as="p" variant="sectionEyebrow">
        {t.featured}
      </Text>
      <div className="grid grid-cols-1 tablet:grid-cols-2 gap-grid desktop:gap-grid-desktop mt-6">
        {featuredArticles.map((a) => (
          <FeaturedArticleCard key={a.slug} article={a} />
        ))}
      </div>
    </div>
  );
};

export default BlogTopSection;

type BlogTopSectionProps = {
  featuredArticles: Article[];
  t: BlogI18n;
};
